module.exports = __webpack_public_path__ + "img/album18_17.7665e862.jpg";